import React from 'react';
import PropTypes from 'prop-types';
import useDeepCompareEffect from 'react-use/lib/useDeepCompareEffect';

const IFrame = ({ html = '', ...props }) => {
  const iframe = React.useRef();
  useDeepCompareEffect(() => {
    const blob = new Blob([html || ''], {
      type: 'text/html; charset=utf-8',
    });
    iframe.current.src = URL.createObjectURL(blob);
  }, [html]);
  return (
    <iframe
      {...props}
      ref={iframe}
      style={{
        width: '100%',
        height: '100%',
        borderWidth: 1,
        borderColor: '#ccc',
        borderStyle: 'solid',
      }}
    />
  );
};

IFrame.defaultProps = {
  html: '',
};

IFrame.propTypes = {
  html: PropTypes.string,
};

export default IFrame;
